import companiesModule from './companies/companies';
import usersModule     from './users/users';
import { settingsModule } from './settings/settings';
import {adminBookingComponent} from './booking/booking.component';

const AdminModule = angular
  .module('admin', [
    companiesModule.name,
    usersModule.name,
    settingsModule.name
  ])
  .component('adminBookingComponent', adminBookingComponent);

export default AdminModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/admin.js
 **/